/**
 * 处理特殊字符的转换映射
 */
const ENCODE_MAP = {
  '\\"': '&quot&',
  "\\'": '&apos&',
  '\\': '&sprit&'
}

const DECODE_MAP = {
  '&quot&': '"',
  '&apos&': "'",
  '&sprit&': '\\'
}

/**
 * 将 Base64 字符串解码为 UTF-8 字符串（支持 URL-safe 变体与自动补齐 =）
 * 传入值先清洗空白（首尾空格、传输/序列化引入的空格与换行）——
 * 混入空白会导致长度 %4 错位或 atob 抛错
 * @param {string} base64Str
 * @returns {string}
 */
export const base64ToUtf8 = (base64Str) => {
  if (typeof base64Str !== 'string') return base64Str

  // 兼容 URL-safe Base64（- _）并自动补齐 =
  const normalized = base64Str.trim().replace(/\s+/g, '').replace(/-/g, '+').replace(/_/g, '/')
  const mod = normalized.length % 4
  const padded = mod === 2 ? normalized + '==' : mod === 3 ? normalized + '=' : normalized
  if (mod === 1) {
    throw new Error('Invalid base64 string')
  }

  // atob -> binary string -> Uint8Array -> UTF-8
  const binary = atob(padded)
  const bytes = new Uint8Array(binary.length)
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i)
  }
  return new TextDecoder().decode(bytes)
}

/**
 * 递归处理对象中的所有字符串值
 * @param {Object} obj - 需要处理的对象
 * @returns {Object} - 处理后的对象
 */
const processObjectStrings = (obj) => {
  if (typeof obj !== 'object' || obj === null || obj === undefined || obj === '') {
    return obj
  }

  if (Array.isArray(obj)) {
    return obj.map((item) => processObjectStrings(item))
  }

  const result = {}
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const value = obj[key]
      // 用户昵称字段需要进行base64解码
      if (['playerName', 'nickName', 'receiverName', 'senderName', 'homeTeamName', 'awayTeamName'].includes(key)) {
        // 如果key是playerName，为用户昵称，进行base64解码
        result[key] = base64ToUtf8(value)
      } else {
        if (typeof value === 'string') {
          result[key] = value.replace(/&quot&|&apos&|&sprit&/g, (match) => DECODE_MAP[match])
        } else {
          result[key] = processObjectStrings(value)
        }
      }
    }
  }
  return result
}

/**
 * 处理JSON字符串中的特殊字符
 * @param {string} jsonString - 输入的JSON字符串
 * @returns {Object} - 处理后的对象
 */
export const processJsonString = (jsonString) => {
  if (!jsonString) return null
  try {
    // 第一步：替换双引号,单引号
    let processedString = jsonString.replace(/\\"/g, ENCODE_MAP['\\"'])
    processedString = processedString.replace(/\\'/g, ENCODE_MAP["\\'"])

    // 第二步：替换反斜杠
    processedString = processedString.replace(/\\/g, ENCODE_MAP['\\'])

    // 第三步：解析JSON
    const parsedObj = JSON.parse(processedString)

    // 第四步：递归处理所有字符串
    return processObjectStrings(parsedObj)
  } catch (error) {
    console.error('处理JSON字符串时出错:', error)
    return null
  }
}
